const config = [
  {
    header: 'Demographics',
    trackingFieldName: 'demographics_open',
    className: 'clDemographics',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [{ text: 'Population' }, { key: 'population' }],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Population growth from 2010 to 2011' },
          {
            key: 'percent_population_change',
            type: 'percent',
            formatterStr: '0.00%',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Percent women' },
          { key: 'percent_women', type: 'percent', formatterStr: '0.00%' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Ratio of unmarried men to women' },
          { key: 'ratio_unmarried_men_women' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: "Percent population with Bachelor's degree" },
          { key: 'percent_college', type: 'percent', formatterStr: '0.00%' },
        ],
      },

      {
        type: 'variable',
        rows: [{ text: 'Diversity rating' }, { key: 'diversity_rating' }],
      },

      {
        type: 'variable',
        rows: [
          { text: 'Percent foreign born' },
          {
            key: 'percent_foreign_born',
            type: 'percent',
            formatterStr: '0.00%',
          },
        ],
      },
      {
        type: 'variable',
        rows: [{ text: 'Median age' }, { key: 'median_age' }],
      },
    ],
  },
  {
    header: 'Local Economy',
    trackingFieldName: 'economy_open',
    className: 'clEconomy',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'Average salary per person' },
          { key: 'annual_per_capita_income', type: 'currency' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Unemployment rate' },
          { key: 'unemployment_rate', type: 'percent', formatterStr: '0.00%' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Percent below poverty' },
          {
            key: 'percent_below_poverty',
            type: 'percent',
            formatterStr: '0.00%',
          },
        ],
      },
    ],
  },
  {
    header: 'Households',
    trackingFieldName: 'households_open',
    className: 'clHouseholds',
    help: '',
    contentConfig: [
      {
        type: 'variable',
        rows: [
          { text: 'People per household' },
          {
            key: 'persons_per_household',
            type: 'percent',
            formatterStr: '0.00',
          },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Median household salary' },
          { key: 'median_salary', type: 'currency' },
        ],
      },
      {
        type: 'variable',
        rows: [
          { text: 'Home ownership rate' },
          {
            key: 'percent_home_ownership_rate',
            type: 'percent',
            formatterStr: '0.00%',
          },
        ],
      },
    ],
  },
];
export default config;
